<template>
  <b-navbar toggleable="sm" type="light" variant="light" sticky>
    <b-navbar-brand href="/">
      <img src="../assets/logo.png" width="180" height="60" alt="Bluedio">
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-navbar-nav class="ml_rev">
      <b-nav-form>
        <b-nav-item href="#" @click="toArticles()" class="my-2">
          <i class="far fa-eye"></i>
          {{$t("message.News")}}
        </b-nav-item>

        <b-button v-b-modal.modal-service variant="light">
          <i class="fas fa-th-large"></i>
          {{$t("message.Service")}}
        </b-button>

        <b-modal id="modal-service" :title="$t('message.Service')" hide-footer>
          <b-list-group>
            <b-list-group-item
              href="#"
              @click="toCustomize()"
              variant="light"
            >{{$t("message.Customized_Service")}}</b-list-group-item>
            <b-list-group-item
              href="#"
              variant="success"
              @click="toAppDownL()"
            >{{$t("message.APP_Download")}}</b-list-group-item>
            <b-list-group-item href="#" @click="toManual()" variant="light">{{$t("message.Instruction_Book")}}</b-list-group-item>
          </b-list-group>
        </b-modal>

        <b-nav-item href="#" @click="toVideo()" class="my-2">
          <i class="fas fa-video"></i>
          {{$t("message.Video")}}
        </b-nav-item>
        <b-nav-item href="#" @click="toForum()" class="my-2 mx-2">
          <i class="far fa-comments"></i>
          {{$t("message.Forum")}}
        </b-nav-item>
      </b-nav-form>
    </b-navbar-nav>

    <b-collapse id="nav-collapse" is-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto justify-content-center align-items-center">
        <b-nav-item
          href="#"
          v-b-modal.modal-1
          :class="{'d-none':access_token!=''}"
        >{{ $t("message.Login") }}</b-nav-item>

        <b-nav-item
          href="#"
          v-b-modal.modal-2
          :class="{'d-none':access_token!=''}"
        >{{ $t("message.Register") }}</b-nav-item>


         <b-nav-item href="#" @click="toUcenter()" :class="{'d-none':access_token==''}">
          <i class="fas fa-user-alt"></i>
          {{loginname}}
        </b-nav-item>

        <b-nav-item-dropdown id="dropdown-right" right :text="lang" no-caret>
          <b-dropdown-item-button @click="changeLan('cn')">中文</b-dropdown-item-button>
          <b-dropdown-item-button @click="changeLan('en')">English</b-dropdown-item-button>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
    <b-modal id="modal-1" ref="modal-1" :title="$t('message.Login')" hide-footer>
      <b-form>
        <b-form-group :label="$t('message.UserName')" label-for="input-usrname">
          <b-form-input id="input-usrname" v-model="usrname" required placeholder="Enter name"></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('message.Password')" label-for="input-psw">
          <b-form-input
            id="input-psw"
            v-model="psw"
            type="password"
            required
            placeholder="Password"
          ></b-form-input>
        </b-form-group>
        <b-button
          type="button"
          variant="outline-dark"
          @click="login(usrname,psw)"
        >{{ $t("message.Login") }}</b-button>
   <small
          class="form-text text-danger"
          :class="{'d-none':rsl_login}"
        >{{$t('message.Usr_Psw_Erro') }}</small>
        <div class="mt-3">
          <p @click="fogpsw()" data-dismiss="modal">{{ $t("message.LOST_PASSWORD") }}</p>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-2" ref="modal-2" :title="$t('message.Register')" hide-footer>
      <form>
        <div class="form-group">
          <label for="exampleInputaUsrName">{{ $t("message.Username_Email_Phone") }}</label>
          <input
            type="text"
            class="form-control"
            id="exampleInputaUsrName"
            aria-describedby="emailHelp"
            placeholder="Enter username"
            v-model="reqUsrName"
            required
          >
        </div>
        <div class="form-group">
          <label for="exampleInputPassword1">{{ $t("message.Password") }}</label>
          <input
            type="password"
            class="form-control"
            id="exampleInputPassword1"
            placeholder="Password"
            v-model="reqPsw"
            required
          >
        </div>
        <div class="form-group">
          <label for="reqemail">{{ $t("message.email") }}</label>
          <input
            type="email"
            class="form-control"
            id="reqemail"
            aria-describedby="emailHelp"
            placeholder="Enter email"
            v-model="reqEmail"
            required
          >
        </div>
        <button
          type="button"
          class="btn btn-primary"
          @click="req(reqUsrName, reqPsw,reqEmail)"
        >{{ $t("message.Sign_Up") }}</button>
        <small
          class="form-text text-danger"
          :class="{'d-none':rsl}"
          v-if="lan=='en'"
        >{{ reg_msg_en }}</small>
        <small
          class="form-text text-danger"
          :class="{'d-none':rsl}"
          v-if="lan=='cn'"
        >{{reg_msg_cn }}</small>
      </form>
    </b-modal>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "HeadCommSection",
  data() {
    return {
      rsl: true,
      rsl_login: true,
      reg_msg_en: "",
      reg_msg_cn: "",
      items_one: [],
      items_two: []
    };
  },
   mounted() {
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      this.rsl = true;
      this.rsl_login = true;
    });
  },
  computed: {
    ...mapGetters(["lang", "loginname", "access_token"])
  },
  created() {
    // this.getNavCategoris();
  },
  methods: {
    ...mapActions({
      getNavCategoris(dispatch) {
        dispatch("getNavCategoris", {}).then(data => {
          this.info = data;
          if (data.result) {
            this.items_one = data.items;
          }
        });
      },

      req(dispatch, reqUsrName, reqPsw, reqEmail) {
        if (reqUsrName === "" || reqPsw === "" || reqEmail === "") {
          return;
        }
        dispatch("req", { reqUsrName, reqPsw, reqEmail }).then(data => {
          this.rsl = data.result;
          if (data.result) {
            //  this.$router.go(0);
            this.login(reqUsrName, reqPsw);
            this.hideModal2();
          } else {
            this.reg_msg_en = data.message_en;
            this.reg_msg_cn = data.message;
          }
        });
      },
      login(dispatch, usrname, psw) {
        if (usrname === "" || psw === "") {
          return;
        }
        this.$store.state.items_cart = [];
        dispatch("login", { usrname, psw }).then(data => {
         this.rsl_login = data.result;
          if (data.result) {
            this.$store.state.loginname = usrname;
            // this.$store.state.access_token = data.access_token
            localStorage.setItem("token", JSON.stringify(data.access_token));
            localStorage.setItem("usrname", JSON.stringify(usrname));
            localStorage.setItem("usrid", JSON.stringify(data.user.id));
            this.$store.state.usr = data.user;
            this.$store.state.access_token = data.access_token;
            this.hideModal();
          }
        });
      }
    }),
    changeLan(lan) {
      this.$store.state.lan = lan;
      this.$i18n.locale = lan;
      localStorage.setItem("lan", lan);
    },
    hideModal() {
      this.$refs["modal-1"].hide();
    },
    hideModal2() {
      this.$refs["modal-2"].hide();
    },
    toArticles() {
      this.$router.push({
        name: "enArticleLs"
      });
    },
    toVideo() {
      this.$router.push({
        name: "enVideo"
      });
    },
    toForum() {
      this.$router.push({
        name: "enForum"
      });
    },
    toManual() {
      this.$router.push({
        name: "enManual"
      });
    },
    toAppDownL() {
      window.location = "https://bluedio.com/app.html";
    },
    toCustomize() {
      this.$router.push({
        name: "enCustomize"
      });
    },
    toUcenter() {
      this.$router.push({
        name: "enUcenter"
      });
    },
    toHome() {
      this.$router.push({
        name: "enhome"
      });
    }
  }
};
</script>
